module.exports = __webpack_public_path__ + "fonts/geograph-web-regular.6982157f.woff";